import { FC } from 'react';

import { Box, styled, BoxProps, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import useIcon from '../../hooks/useIcon';

const Circle = styled(Box)({
  zIndex: 99,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  borderRadius: '50%',
  borderStyle: 'solid',
  borderColor: 'white',
  borderWidth: '5px',
  color: 'white',
});

const StyledImage = styled('img')({
  width: '60%',
  height: '60%',
});

interface Props {
  iconColor?: string;
  iconSize?: number;
  customStyle?: BoxProps;
  iconName?: string;
}

const CardCircle: FC<Props> = observer(props => {
  const { iconSize, iconColor, customStyle, iconName } = props;

  const { palette } = useTheme();

  const currentIcon = useIcon(iconName);

  return (
    <Circle
      bgcolor={iconColor || palette.secondary.main}
      width={iconSize || 100}
      height={iconSize || 100}
      {...customStyle}
    >
      <StyledImage src={currentIcon} alt="Icon" />
    </Circle>
  );
});

export default CardCircle;
